import { Button, Grid, InputAdornment, TextField } from "@mui/material";
import { useSuperAdminPlans } from "../../../context/SuperAdmin/PlanContext";
import { useAuthContext } from "../../../hooks/Auth";
import SearchIcon from "@mui/icons-material/Search";

const HeadersPlanTable = () => {
  const { toggleCreateModal, searchText, setSearchText } = useSuperAdminPlans();
  const { canAccess } = useAuthContext();

  return (
    <Grid
      container
      sx={{ justifyContent: "space-between", alignContent: "center" }}
    >
      <Grid item>
        {/* Search bar */}
        <TextField
          size="small"
          variant="outlined"
          placeholder="Ej: Plan Oro"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      {canAccess("create:plans") && (
        <Grid item>
          <Button
            variant="contained"
            onClick={() => toggleCreateModal(true)}
            sx={{ background: "#336B87" }}
          >
            Crear plan
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default HeadersPlanTable;
